<template>
  <div style="width: 100%; height: 100%">
    <div class="edit-main">
      <!-- 左侧索引 -->
      <div class="left-index">
        <div v-for="(item, index) of height" :key="index">
          <span :class="errorObj.indexArr.indexOf(item) !== -1 ? 'error-left' : ''">{{
            item
          }}</span>
        </div>
      </div>
      <!-- 右侧内容 -->
      <div class="content">
        <div v-for="(item, index) of resultArr" :key="index" class="row-class">
          <!-- <span>{{item}}</span> -->
          <div style="width: 100%">
            <el-input v-model="resultArr[index]" style="width: 100%" @input="validFun(index)" @paste.native="pasteFun($event, index)">
            </el-input>
          </div>

          <svg-icon icon-class="delete-cha" class="svg-class" @click.native="deleteRow(index)" />
        </div>
        <!-- 最后一行效果 -->
        <div class="result-row" v-if="resultArr.length<max">
          <el-input v-model="newRow" @keyup.enter.native="changeFun" :placeholder="'请输入或粘贴' + label + '，每行一个' + label + '，敲击回车确认并换行'" id="lastRow" @input="validFun()" @paste.native="pasteFun($event)">
            <template v-slot:append>
              <span>{{ newRow.length }}/{{inputLength}}</span>
            </template>
          </el-input>
        </div>
      </div>
    </div>

    <!-- error提示 -->
    <div class="tip" :title="errorObj.errorText">{{ errorObj.errorText }}</div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    oldArr: Array, //获取已有数据的方式
    //校验是否判重
    isRepeat: {
      type: Boolean,
      default: false,
    },
    // 最大行数
    max: {
      type: Number,
      default:100,
    },
    // 输入长度
    inputLength: {
      type: Number,
      default:30,
    },
    label: {
      type: String,
      default: "行为词",
    },
    validSource: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      resultArr: [],
      height: 0,
      newRow: "",
      //报错信息展示 
      errorObj: {
        //报错索引数组，从零起始(重复)
        indexArr: [],
        //错误显示文字
        errorText: "",
      },
    };
  },
  created() {
    this.resultArr = this.oldArr ? this.oldArr : this.resultArr;
  },
  mounted() {
    this.$nextTick(() => {
      this.handleScroll();
      console.log(this.height, "mounted,mounted,mm");
    });
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    //滚动计算行高
    handleScroll() {
      let tempArr = document.getElementsByClassName("edit-main");
      if (tempArr.length !== 0) {
        this.height = parseInt(tempArr[tempArr.length - 1].scrollHeight / 40);
      }
    },

    // 重复校验
    validFun(index) {
      if (this.isRepeat) {
        let errorIndex = [];
        // 处理数据
        if (this.validSource.length > 0) {
          let exitArr = [];
          this.validSource.map((item) => {
            exitArr.push(item.label);
          });
          let tempArr = this.resultArr.concat([this.newRow]);
          tempArr.map((item, i) => {
            exitArr.map((ele, j) => {
              if (item === ele && item) {
                errorIndex.push(i + 1);
              }
            });
          });
        }

        this.isRepeatAndNull(errorIndex);
      }
    },
    pasteFun(e, flagIndex) {
      //粘贴事件处理数据
      let oldRow =
        typeof flagIndex === "number" ? this.resultArr[flagIndex] : this.newRow;
      let clipboardData = e.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData("text");
      // console.log(e, "oldold=====");
      // console.log(pastedData, "粘贴文本=====");
      const arr = pastedData.split("\n");
      if (arr.length > 1) {
        if (typeof flagIndex === "number") {
          //处理修改粘贴的情况
          // this.newRow = oldRow + arr[0]
          this.resultArr[flagIndex] = oldRow + arr[0];
        } else {
          //输入行粘贴的情况
          this.resultArr = this.resultArr.concat(arr);

          let that = this;
          setTimeout(function () {
            that.newRow = oldRow;
          }, 10);
        }
      }
      this.isRepeatAndNull();
    },

    //最终行回车事件
    changeFun() {
      if(this.resultArr.length>=this.max){
        this.errorObj.indexArr = [];
        this.errorObj.errorText = "最多输入" + this.max + "行";
        return;
      }
      //校验通过后续操作
      this.resultArr.push(this.newRow);
      this.newRow = "";
      //当无重复时校验为空
      this.isRepeatAndNull();

      //滚动条默认到最底部
      this.$nextTick(() => {
        let tempArr = document.getElementsByClassName("edit-main");
        tempArr[tempArr.length - 1].scrollTop = tempArr[tempArr.length - 1].scrollHeight;
      });
    },

    //删除行
    deleteRow(index) {
      //正常删除行~
      this.resultArr.splice(index, 1);
      //删除错误行时~
      this.isRepeatAndNull();
    },
    //清除错误词
    clearError() {
      let that = this;
      //判断最后行重复时删除
      if (this.errorObj.indexArr.indexOf(that.resultArr.length + 1) > -1) {
        that.newRow = "";
      }
      this.errorObj.indexArr.map((item, index) => {
        that.resultArr.splice(item - 1 - index, 1);
      });

      this.errorObj.indexArr = [];
      this.errorObj.errorText = "";
    },
    //清空
    clear() {
      this.resultArr = [];
      this.newRow = "";
      this.errorObj.indexArr = [];
      this.errorObj.errorText = "";
    },
    //当无重复时校验为空
    isNullFun() {
      //当无重复时校验为空
      if (this.errorObj.errorText.indexOf("重复") === -1) {
        let tempArr = [];
        this.resultArr.map((item, resultArrIndex) => {
          if (item === "") {
            tempArr.push(resultArrIndex + 1);
          }
        });
        this.errorObj.indexArr = tempArr;
        // 错误提示
        if (this.errorObj.indexArr.length > 0) {
          this.errorObj.errorText = "存在空行：";

          this.errorObj.indexArr.map((item) => {
            this.errorObj.errorText += "第" + item + "行 ";
          });
        }
      }
    },
    //校验超长的情况
    validLength() {
      if (
        this.errorObj.errorText.indexOf("重复") === -1 &&
        this.errorObj.errorText.indexOf("空行") === -1
      ) {
        let errorIndex = [];
        let tempArr = this.resultArr//.concat([this.newRow]);
        tempArr.map((item, resultArrIndex) => {
          if (item.length > this.inputLength) {
            errorIndex.push(resultArrIndex + 1);
          }
        });
        this.errorObj.indexArr = errorIndex;
        // 错误提示
        if (this.errorObj.indexArr.length > 0) {
          this.errorObj.errorText = "以下标题字数超过"+this.inputLength+"个字规范：";

          this.errorObj.indexArr.map((item) => {
            this.errorObj.errorText += "第" + item + "行 ";
          });
        }
      }
    },
    //判断当前页面重复和为空
    isRepeatAndNull(arr) {
      this.errorObj.indexArr = [];
      this.errorObj.errorText = "";

      let tempArr = arr ? arr : [];
      let lastIsRepeat = false;
      //计算当前页面已回车数据
      for (let i = this.resultArr.length - 1; i >= 0; i--) {
        for (let j = i - 1; j >= 0; j--) {
          if (this.resultArr[i] === this.resultArr[j] && this.resultArr[i]) {
            tempArr.push(i + 1);
          }
        }
        if (this.resultArr[i] === this.newRow && this.newRow) {
          lastIsRepeat = true;
        }
      }
      //计算最后行是否重复
      if (lastIsRepeat) {
        tempArr.push(this.resultArr.length + 1);
      }

      //对错误行从小到大排序
      this.errorObj.indexArr = tempArr;
      this.errorObj.indexArr.sort((a, b) => {
        return a - b;
      });

      // 错误提示
      if (this.errorObj.indexArr.length > 0) {
        this.errorObj.errorText = "以下" + this.label + "重复：";

        this.errorObj.indexArr.map((item) => {
          this.errorObj.errorText += "第" + item + "行 ";
        });
      } else {
        this.errorObj.errorText = "";
      }
      //当无重复时校验为空
      this.isNullFun();
      //校验字符串长度超长
      this.validLength();
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-main {
  width: 100%;
  height: calc(100% - 23px);
  overflow: auto;
  display: flex;
  border: solid #e5e5e5 1px;
  ::v-deep .el-input__count-inner {
    font-size: 14px;
    background: none;
  }

  .left-index {
    width: 32px;
    background-color: #f5f5f5;
    div {
      line-height: 40px;
      text-align: center;
      background-color: #f5f5f5;
      color: #999;
      font-size: 12px;
    }

    .error-left {
      background: #ff0000;
      width: 25px;
      height: 20px;
      color: #fff;
      border-radius: 5px;
      text-align: center;
      line-height: 20px;
      position: relative;
      display: inline-block;
      &::after {
        content: "";
        border: 4px solid #ff0000;
        position: absolute;
        width: 0;
        height: 0;
        // border: 4px solid #f45858;
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        right: -8px;
        top: 5.5px;
      }
    }
  }
  .content {
    width: 100%;
    .row-class {
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .svg-class {
      font-size: 20px;
      color: #999;
      margin-right: 20px;
      cursor: pointer;
    }
    ::v-deep .el-input__inner {
      border: none;
      border-radius: 1px;
    }
    ::v-deep .el-input-group__append{
      background-color:rgba(58,137,255,.1);
      border:none;
    }
  }
  .result-row {
    ::v-deep .el-input__inner {
      border: none;
      background: rgba(58, 137, 255, 0.1);
      border-radius: 1px;
    }
  }
}
.tip {
  color: #ff0000;
  font-size: 12px;
  margin-top: 10px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
